import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

export class FormUtil {

  static isValid(formGroup: FormGroup, component: Array<string | number> | string): boolean {
    return formGroup.get(component).valid || formGroup.get(component).pristine;
  }

  static getFormArray(formGroup: FormGroup, component: string): FormArray {
    return formGroup.get(component) as FormArray;
  }


  static commaSepEmail = (control: AbstractControl): { [key: string]: any } | null => {
    if (!control.value) {
      return null;
    }

    const emails = control.value.split(',').map(e => e.trim());

    for (let email of emails) {
      let result = Validators.email(new FormControl(email));
      if (result) {
        return result;
      }
    }

    return null;
  };
}
